module.exports = __webpack_public_path__ + "img/公司资质.5258a308.png";